export function getStorageItem(storageType) {
  return function (name) {
    var _storage$getItem;
    const storage = storageType === "local" ? localStorage : sessionStorage;
    return JSON.parse((_storage$getItem = storage.getItem(name)) !== null && _storage$getItem !== void 0 ? _storage$getItem : "null");
  };
}
//# sourceMappingURL=getStorageItem.js.map